import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class FormDataService {

  createFormData<T>(jsonObject: T, jsonObjectName: string, files: File[]) {
    const formData = new FormData();
    formData.append(jsonObjectName, JSON.stringify(jsonObject));
    files.forEach(file => formData.append(file.name, file, file.name));
    return formData;
  }

  getFormDataHeaders(): HttpHeaders {
    // enviando o content-type vazio, o browser completa com o dele, utilizando seu próprio boundary
    return new HttpHeaders().set('Content-Type', '').set('Name', 'file').set('Accept', '*/*');
    // .set('User-Agent', 'selecao.vitoria.es.gov.br')

  }

  getFormDataHeadersType(mimeType: string): HttpHeaders {
    return new HttpHeaders().set('Content-Type', mimeType);
  }

  getFormDataHeadersXClient(): HttpHeaders {
    // enviando o content-type vazio, o browser completa com o dele, utilizando seu próprio boundary
    return new HttpHeaders().set('X-Client', 'krYIt9WqZmflhRUPfucktA01bAi01zLx6DCM');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/api/form-data.service.ts